import axios from 'axios';
import { BABYFACE_URL } from '../../lib/routes/Routes';
import { ERROR_RETRY } from '../../lib/Error';

export const reloadUltrasound = async ({ itemId, files }) => {
  try {
    const response = await axios.post(
      BABYFACE_URL.concat(`/ultrasound/request/${itemId}/reload`),
      files,
    );
    return response.data;
  } catch (e) {
    alert(ERROR_RETRY);
  }
};
